import { clamp, inRange } from 'lodash';

import generateNewOptionModel from 'sharedParts/utils/generateNewOptionModel';
import numbering from 'sharedParts/utils/numbering';

export default (defaultLabel = '') => (collection, { min, max }) =>
  inRange(collection.length, min, max)
    ? collection
    : Array.from(
        { length: clamp(collection.length, min, max) },
        (item, index) =>
          collection[index] ||
          generateNewOptionModel(`${defaultLabel} ${numbering.toHuman(index)}`),
      );
